import { render, staticRenderFns } from "./EditIndoorSettingArea.vue?vue&type=template&id=89b998a6&scoped=true&"
import script from "./EditIndoorSettingArea.vue?vue&type=script&lang=js&"
export * from "./EditIndoorSettingArea.vue?vue&type=script&lang=js&"
import style0 from "./EditIndoorSettingArea.vue?vue&type=style&index=0&id=89b998a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b998a6",
  null
  
)

export default component.exports